export default __webpack_public_path__ + "static/media/tezpay.7917c0ba.png";